import {
  combineReducers,
  configureStore,
  createListenerMiddleware,
} from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import storage from "redux-persist/lib/storage";
import { baseApi } from "@/api";
import {
  // reducers
  parentReducer,
} from "./Slice";

// UI REDUCERS
import LoginReducer from "@/slices/auth/login/reducer";
import CalendarReducer from "@/slices/calendar/reducer";
import LayoutReducer from "@/slices/layouts/reducer";

const persistConfig = {
  key: "root",
  storage,
  timeout: null,
  blacklist: ["parent.errorMsg"],
};
const logger = createLogger();

const reducer = combineReducers({
  // Front
  Layout: LayoutReducer,
  // Authentication
  Login: LoginReducer,
  // Calendar
  Calendar: CalendarReducer,
  // API
  parent: parentReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

const rootListener = createListenerMiddleware();

const middlewares = [logger];

const isDevelopment = process.env.NODE_ENV === "development";

// const persistedReducer = persistReducer(persistConfig, reducer);

export const apiStore = configureStore({
  reducer: reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // serializableCheck: {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      // },
    })
      .prepend(rootListener.middleware)
      .concat(baseApi.middleware)
      .concat(middlewares),
  devTools: isDevelopment,
});

// export const persistor = persistStore(apiStore);
